import { useState } from "react";
import { Modal } from "react-bootstrap";
import Accordion from "react-bootstrap/Accordion";
import { Link } from "react-router-dom";
import Breadcrumb from "../Component/Breadcrumb";
import Footer from "../Component/Footer";
import Header from "../Component/Header";
import Menu from "../Component/Menu";
import PageTitle from "../Component/PageTitle";
import LazyLoad from "react-lazyload";

const FortnightlyMagazine = () => {
  const homeMenu = [
    { label: "Latest Update", link: "/news" },
    { label: "Testimonials", link: "/testimonial" },
    { label: "School Calendar", link: "/calender" },
    { label: "CBSE Circulars", link: "/circular" },
    { label: "eMagazine", link: "/Magazine" },
    { label: "TAABIR Digital Dreams", link: "/digitaldreams" },
    { label: "Fortnightly School Magazine", link: "/fortnightlyMagazine" },
    { label: "Carpe Diem'22 ", link: "/carpediem" },
  ];

  const [showModal, setShowModal] = useState(false);
  const [selectedMagazine, setSelectedMagazine] = useState({
    title: "",
    url: "",
  });

  const handleOpenModal = (title, url) => {
    setSelectedMagazine({ title, url });
    setShowModal(true);
  };

  const handleCloseModal = () => setShowModal(false);

  return (
    <>
      <Header />
      <Breadcrumb breadImage="https://webapi.entab.info/api/image/LVISGURGAON/public/Images/banner-school.jpg" />
      <Menu MenuItem={homeMenu} />

      <div className="padding-blk inner-page">
        <div className="container-fluid">
          <div className="row">
            <div className="col-md-12">
              <PageTitle
                pageTitle="Fortnightly School Magazine"
                breadEnd="Fortnightly School Magazine"
                breadMid="Fortnightly School Magazine"
              />
            </div>
          </div>
          <div className="row">
            <div className="col-md-12">
              <Accordion defaultActiveKey="0">
                <Accordion.Item eventKey="0">
                  <Accordion.Header>
                    Fortnightly School Magazine
                  </Accordion.Header>
                  <Accordion.Body>
                    <div className="d-flex flex-wrap gap-2">
                      {[
                        {
                          title: "The LVISG Times 13th Edition",
                          img: "hjco-wqbh.jpg",
                          url: "https://online.anyflip.com/hjco/wqbh/index.html",
                        },
                        {
                          title: "The LVISG Times 12th Edition",
                          img: "hjco-duan.jpg",
                          url: "https://online.anyflip.com/hjco/duan/index.html",
                        },
                        {
                          title: "The LVISG Times 11th Edition",
                          img: "giovorvqc.jpg",
                          url: "https://online.anyflip.com/giovo/ykqw/index.html",
                        },
                        {
                          title: "The LVISG Times 10th Edition",
                          img: "LVISG-Times-Edition-10.jpg",
                          url: "https://online.anyflip.com/hjco/klsm/index.html",
                        },
                        {
                          title: "The LVISG Times 9th Edition",
                          img: "hjcoymym.jpg",
                          url: "https://online.anyflip.com/hjco/flkj/index.html",
                        },
                        {
                          title: "The LVISG Times 8th Edition",
                          img: "shot25221.jpg",
                          url: "https://online.anyflip.com/sdtqz/ybgk/index.html",
                        },
                        {
                          title: "The LVISG Times 7th Edition",
                          img: "shot81221.jpg",
                          url: "https://online.anyflip.com/hjco/xmst/index.html",
                        },
                        {
                          title: "The LVISG Times 6th Edition",
                          img: "shot91021.jpg",
                          url: "https://online.anyflip.com/hjco/blom/index.html",
                        },
                        {
                          title: "The LVISG Times 5th Edition",
                          img: "shot44.jpg",
                          url: "https://online.anyflip.com/hjco/dzlu/index.html",
                        },
                        {
                          title: "The LVISG Times 4th Edition",
                          img: "shot-4.jpg",
                          url: "https://online.anyflip.com/hjco/jlas/index.html",
                        },
                        {
                          title: "The LVISG Times 3rd Edition",
                          img: "shot3.jpg",
                          url: "https://online.anyflip.com/hjco/vbst/index.html",
                        },
                        {
                          title: "The LVISG Times 2nd Edition",
                          img: "shot1.jpg",
                          url: "https://online.anyflip.com/hjco/pwge/index.html",
                        },
                        {
                          title: "The LVISG Times 1st Edition",
                          img: "fortnightly-middle-school-magazine.jpg",
                          url: "https://online.anyflip.com/hjco/cyod/index.html",
                        },
                      ].map((item, idx) => (
                        <div
                          key={idx}
                          className="magazine"
                          style={{ cursor: "pointer", width: "200px" }}
                          onClick={() => handleOpenModal(item.title, item.url)}>
                          <LazyLoad>
                            <img
                              src={`https://webapi.entab.info/api/image/LVISGURGAON/public/Images/${item.img}`}
                              alt={item.title}
                              className="img-fluid"
                            />
                          </LazyLoad>
                          <p>{item.title}</p>
                        </div>
                      ))}
                    </div>
                  </Accordion.Body>
                </Accordion.Item>
              </Accordion>
            </div>
          </div>
        </div>
      </div>

      {/* Modal */}
      <Modal show={showModal} onHide={handleCloseModal} size="xl" centered>
        <Modal.Header closeButton>
          <Modal.Title>{selectedMagazine.title}</Modal.Title>
        </Modal.Header>
        <Modal.Body style={{ height: "80vh" }}>
          <iframe
            src={selectedMagazine.url}
            width="100%"
            height="100%"
            style={{ border: "none" }}
            title={selectedMagazine.title}></iframe>
        </Modal.Body>
      </Modal>

      <Footer />
    </>
  );
};

export default FortnightlyMagazine;
